<template>
  <tr class="border-strokes border-t border-solid">
    <td class="w-52 px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>
    <td class="w-40 px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="80" dynamic /></div>
    </td>

    <td class="min-w-40 px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="25" width="120" dynamic /></div>
    </td>
    <td class="w-20 px-4! py-2!">
      <div class="flex justify-center"><RfBaseSkeleton height="24" width="24" /></div>
    </td>
    <td class="w-6 px-4! py-2!">
      <div class="flex"><RfBaseSkeleton height="24" width="24" /></div>
    </td>
  </tr>
</template>

<script setup>
import RfBaseSkeleton from "@/components/skeletons/RfBaseSkeleton.vue";
</script>
